import React, {useState} from "react";
import './header.css';

const Header = () => {
    const [Toggle, showMenu] = useState(false);

    return (
        <header className='header'>
            <nav className="container nav">
                <a href="/" className="nav__logo">
                    Olieinik
                </a>

                <div className={Toggle ? 'nav__menu show-menu' : 'nav__menu'}>
                    <ul className="grid nav__list">
                        <li className="nav__item">
                            <a href="#home" className="nav__link">
                                <i className="nav__icon uil uil-estate"></i> Home
                            </a>
                        </li>
                        <li className="nav__item">
                            <a href="#about" className="nav__link">
                                <i className="nav__icon uil uil-user"></i> About
                            </a>
                        </li>
                        <li className="nav__item">
                            <a href="#skills" className="nav__link">
                                <i className="nav__icon uil uil-file-alt"></i> Skills
                            </a>
                        </li>
                        <li className="nav__item">
                            <a href="#qualification" className="nav__link">
                                <i className="nav__icon uil uil-briefcase-alt"></i> Qualification
                            </a>
                        </li>
                        <li className="nav__item">
                            <a href="#portfolio" className="nav__link">
                                <i className="nav__icon uil uil-scenery"></i> Portfolio
                            </a>
                        </li>
                        <li className="nav__item">
                            <a href="#contact" className="nav__link">
                                <i className="nav__icon uil uil-message"></i> Contact
                            </a>
                        </li>
                    </ul>

                    <i className='nav__close uil uil-times' onClick={() => showMenu(!Toggle)}></i>
                </div>
                <div className="nav__toggle" onClick={() => showMenu(!Toggle)}>
                    <i className='uil uil-apps'></i>
                </div>
            </nav>
        </header>
    )
}

export default Header